/** @format */

import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'antd';
// import Address from '../../../components/Address';
import SeachButton from './components/SeachButton';
import SideBar from './components/Sidebar';
import CartIcon from './components/CartIcon';
import { IMAGES } from '../../../../../../v2-config/constants/images.constant';
import './style.scss';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { Service } from './service';
import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import { isHomeRedesignEnabled } from '../../../../../../v2-config/constants/pharmacy-features.constant';

const NavBarMobile = ({ navBar, status }) => {
	const [isScroll, setScroll] = useState(0);
	const isRedesignEnabled = isHomeRedesignEnabled();
	const headerRef = useRef(null);
	const [headerHeight, setHeaderHeight] = useState(null);

	// The header is fixed, so the spacer must track its real height (logo/cart sizes vary by tenant asset).
	useEffect(() => {
		const header = headerRef.current;
		if (!isRedesignEnabled || !header || typeof window.ResizeObserver !== 'function') return undefined;
		const observer = new window.ResizeObserver(() => setHeaderHeight(header.offsetHeight));
		observer.observe(header);
		return () => observer.disconnect();
	}, [isRedesignEnabled]);

	useEffect(() => {
		const handleClickOutside = (e) => {
			setScroll(e.target.documentElement.scrollTop);
		};
		document.addEventListener('scroll', handleClickOutside);
		return () => {
			document.removeEventListener('scroll', handleClickOutside);
		};
	}, []);

	
		const [modules, setModules] = useState([]);
		const [loadingModules, setLoadingModules] = useState(true);
	
		useEffect(() => {
			new Service()
				.getModulesByTemplate('home', 'ecommerce', Enviroment.ROOT_PHARMACY)
				.then((res) => {
					setModules(res.data);
					setLoadingModules(false);
				})
				.catch((err) => {
					console.error('Error cargando módulos:', err);
					setLoadingModules(false);
				});
		}, []);
	
		const pharmacyHeader = modules.find((m) => m.location === 'header-logo');
		const headerUrl = pharmacyHeader?.image;

	return (
		<>
			<div
				className={`ph-header-mobile-global-spacer${isRedesignEnabled ? ' ph-header-mobile-global-spacer--redesign' : ''}`}
				style={isRedesignEnabled && headerHeight ? { height: `${headerHeight}px` } : undefined}
			></div>
			<div
				ref={headerRef}
				data-testid="ph-header-mobile-global-container"
				className={`${isScroll > 0 ? 'ph-header-mobile-global-container-shadow' : ''}${
					isRedesignEnabled ? ' ph-header-mobile-global-container--redesign' : ''
				} ph-header-mobile-global-container`}
			>
				<div>
					{isRedesignEnabled ? (
						<>
							<Row
								data-testid="ph-header-mobile-top-row"
								className="ph-header-mobile-top-row--redesign ph-header-mobile-normal-container"
							>
								<Col span={2}>
									<div className="ph-header-mobile-sidebar-main-container">
										<SideBar navBar={navBar} status={status} />
									</div>
								</Col>
								<Col span={20} className="ph-header-mobile-logo-container ph-header-mobile-logo-container--redesign">
									{loadingModules ? (
										<></>
									) : (
										<Link to="/">
											<img
												src={headerUrl ? headerUrl : IMAGES.FILE_NOT_AVAILABLE}
												title="logo"
												alt="logo"
												className="ph-header-mobile-logo--redesign"
											/>
										</Link>
									)}
								</Col>
								<Col span={2}>
									<div className="ph-header-mobile-cart-main-container">
										<CartIcon />
									</div>
								</Col>
							</Row>
							<Row
								data-testid="ph-header-mobile-search-row"
								className="ph-header-mobile-search-row--redesign ph-header-mobile-second-row-container"
							>
								<Col span={24}>
									<SeachButton />
								</Col>
							</Row>
						</>
					) : (
						<>
							<Row className={isScroll > 0 ? 'ph-header-mobile-sticky-container' : 'ph-header-mobile-normal-container'}>
								<Col span={12} className="ph-header-mobile-logo-container">
									{loadingModules ? (
										<></>
									) : (
									<Link to='/'>
										<img src={headerUrl ? headerUrl : IMAGES.FILE_NOT_AVAILABLE} title="logo" alt="logo" style={{ height: '25px', marginLeft: '10px' }} />
									</Link>
									)}
								</Col>
								{/* <Col span={12} className="ph-header-mobile-address-container">
									<Address />
								</Col> */}
							</Row>
							<Row className={isScroll > 0 ? 'ph-header-mobile-second-row-sticky-container' : 'ph-header-mobile-second-row-container'}>
								<Col span={3}>
									<div className="ph-header-mobile-sidebar-main-container">
										<SideBar navBar={navBar} status={status}/>
									</div>
								</Col>
								<Col span={18}>
									<SeachButton />
								</Col>
								<Col span={3}>
									<div className="ph-header-mobile-cart-main-container">
										<CartIcon />
									</div>
								</Col>
							</Row>
						</>
					)}
				</div>
			</div>
		</>
	);
};
export default NavBarMobile;
